import { render } from "./AttachEmail.vue?vue&type=template&id=db59bee0"
import script from "./AttachEmail.vue?vue&type=script&lang=js"
export * from "./AttachEmail.vue?vue&type=script&lang=js"
script.render = render

export default script